function AdminDocUpload({ busy, onSelectFile, label = 'Upload missing document' }) {
  return (
    <label className={`admin-doc-upload ${busy ? 'admin-doc-upload--busy' : ''}`}>
      <input
        type="file"
        accept="image/jpeg,image/png,image/webp"
        disabled={busy}
        onChange={(event) => {
          const file = event.target.files?.[0];
          event.target.value = '';
          if (file) onSelectFile(file);
        }}
      />
      <span className="admin-doc-upload__icon" aria-hidden="true">
        ↑
      </span>
      <span className="admin-doc-upload__text">{busy ? 'Uploading…' : label}</span>
      <span className="admin-doc-upload__hint">JPG, PNG, or WEBP</span>
    </label>
  );
}

export default AdminDocUpload;
